import {
  createTechDocsAddonExtension,
  TechDocsAddonLocations,
} from '@backstage/plugin-techdocs-react';
import { SecondarySidebarAddon } from './components/SecondarySidebarAddon';
import { techdocsExtensionPlugin } from '../../../plugin';

export const SecondarySidebar = techdocsExtensionPlugin.provide(
  createTechDocsAddonExtension({
    name: 'SecondarySidebar',
    location: TechDocsAddonLocations.SecondarySidebar,
    component: SecondarySidebarAddon,
  }),
);
